import React, { useState } from 'react';

const BonusDone = ({ carService, carBonusDate, value, carID }) => {
    const initialCarData = {
        id: carID,
        bonus_done_date: carBonusDate,
        bonus_done: value ? 1 : 0,  
    };

    const [newCar, setNewCar] = useState(initialCarData);

    const onChangeCar = (event) => {

        const updatedCheckValue = event.target.checked ? 1 : 0;  

        const updatedCar = {
            ...newCar,
            bonus_done: updatedCheckValue,
        };
 
        setNewCar(updatedCar);
   
        carService.updateBonusDone(updatedCar)
        .then(response => { 
            carService.fetchList() 
        })
        .catch(error => {
            console.error(error);
        });
 
    }; 



    const formatDate = (dateString) => {
        if (!dateString) {  
            return "";
        }

        const purchasedAtDate = new Date(dateString);

        if (isNaN(purchasedAtDate.getTime())) {
            //console.error("Invalid date provided:", dateString);
            return "";  
        }

        const months = [
            "იან", "თებ", "მარ", "აპრ", "მაი", "ივნ",
            "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"
        ];

        const day = purchasedAtDate.getDate();
        const month = months[purchasedAtDate.getMonth()]; 
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month} ${year}`;
    };

    return (
        <>
            
            <input type="checkbox" checked={newCar.bonus_done === 1} onChange={onChangeCar} />
            <span>{formatDate(newCar.bonus_done_date)}</span>

        </>
    );
};

export default BonusDone;
